import { MenuItem } from "@material-ui/core";
import smallStar from "../../../assets/smallStar.svg";
import { useState, useEffect } from "react";

const CustomMenuItem = (props) => {
  const value = props.value;
  const { filters, setFilters } = props;

  const [star, setStar] = useState(false);

  useEffect(() => {
    setStar(
      value === "FAIR PRICE" ||
        value === "POTENTIAL" ||
        value === "PAST HISTORY" ||
        value === "SOLVENCY" ||
        value === "EARNINGS" ||
        value === "PREZZO EQUO" ||
        value === "POTENZIALE" ||
        value === "SOLVIBILITÀ" ||
        value === "STORICO" ||
        value === "UTILE"
        ? true
        : false
    );
  }, []);

  return (
    <MenuItem
      value={value}
      style={{
        fontSize: "14px",
        fontWeight: 300,
        fontFamily: "Overpass",
        color: "#808080",
      }}
      onClick={() => {
        props.type === "Continent"
          ? setFilters({ ...filters, Continent: value })
          : props.type === "Country"
          ? setFilters({ ...filters, Country: value })
          : setFilters({ ...filters, order_by: value });

        if (props.setIsOpen) {
          props.setIsOpen(false);
          console.log("done");
        }
      }}
    >
      {star ? (
        <span style={{ marginRight: "9px" }}>
          <img src={smallStar}></img>
        </span>
      ) : null}
      {value}
    </MenuItem>
  );
};

export default CustomMenuItem;
